import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MzBaseModal } from 'ngx-materialize';
import { configuracionEsquema } from 'src/app/_models/formularios/configuracionEsquemas.model';

@Component({
  selector: 'app-deletemodal-config-esq',
  templateUrl: './deletemodal-config-esq.component.html',
})
export class DeletemodalConfigEsqComponent extends MzBaseModal {
  // datos de entrada por el servicio de modal
  @Input() public modal_title: string;
  @Input() public modal_body: string;
  @Input() public isComents: boolean = true;
  @Output() onOkModalComment: EventEmitter<String>;
  private comentField: ElementRef;
  public modal_comentario: string;

  public modalOptions: Materialize.ModalOptions = {
    dismissible: false,
    opacity: .5,
    inDuration: 300,
    outDuration: 200,
    startingTop: '100%',
    endingTop: '10%'
  }
  constructor() {
    super();
    this.onOkModalComment = new EventEmitter();
  }
  public id: number;
  public config: configuracionEsquema;

  ngOnInit() {
    this.id;
    this.config = new configuracionEsquema();
  }
  // Aceptando el modal 
  public closeModal() {

    // si no cometario omite esta parte
    if (this.isComents) {
      this.modal_comentario = 'eliminado';
      // no deja salir si no tiene comentario 
      if (this.modal_comentario == null || this.modal_comentario == '') {
        this.comentField.nativeElement.focus();
        return;
      }

      this.onOkModalComment.emit(this.modal_comentario)
      this.modal_comentario = '';
      this.isComents = false;
    }

    this.modalComponent.closeModal();
  }

}
